import * as actionType from '../constants/actionTypes';

const authReducer = (state = { authData: null }, action) => {
  switch (action.type) {
    case actionType.AUTH:{
      //console.log ( action?.data ) ;
      localStorage.setItem('profile', JSON.stringify({ ...action?.data }));
     return { aa : "aa" } ;
      //return { ...state, authData: action.data, loading: false, errors: null };
    }
    case actionType.LOGOUT:
      localStorage.clear();

      //return { ...state, authData: null, loading: false, errors: null };
       return { aa : "aa" } ;
    default:
      return state;
  }
};

export default authReducer;
